import React, { useEffect, useState } from 'react';
import { useLoading } from '~/lib/contexts/LoadingContext';

export const GlobalSpinner = () => {
    const { isLoading } = useLoading();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    // Don't render during SSR
    if (typeof window === 'undefined') return null;

    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-gradient-to-br from-white/5 to-black/15 backdrop-blur-xl">
            <div className="flex flex-col items-center justify-center text-center space-y-8 bg-white/90 rounded-3xl p-12 border border-white/20 shadow-2xl">
                {/* Logo */}
                {isClient && (
                    <img
                        src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/office-hub.avif`}
                        alt="office-hub-logo"
                        width={320}
                        height={91}
                        className="w-80 p-12"
                    />
                )}

                {/* Bubble Loader */}
                <div className="flex items-center justify-center space-x-2">
                    <div className="w-4 h-4 bg-oh-primary rounded-full animate-bounce"></div>
                    <div className="w-4 h-4 bg-oh-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                    <div className="w-4 h-4 bg-oh-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                </div>

                {/* Text Content */}
                <div className="space-y-2">
                    <p className="text-xl text-oh-primary font-bold">
                        BEST DEAL GUARANTEE
                    </p>
                    <p className="text-base text-slate-600 font-medium max-w-md">
                        From a desk, office or an entire floor we guarantee to get you the
                        best deal.
                    </p>
                </div>
            </div>
        </div>
    );
};
